<template>
  <div class="incoming-tender-list-row incoming-tender-list__summary">
    <div class="summary-total-cell">
      {{ $t('Total price') }} — {{ currencySymbol }} {{ addSpaces(listSums.total_sum) }}
    </div>
    <div class="tender-list-cell" :style="{ 'grid-column': '-4/-5' }">
      {{ currencySymbol }} {{ addSpaces(listSums.labour_sum) }}
    </div>
    <div class="tender-list-cell">{{ currencySymbol }} {{ addSpaces(listSums.materials_sum) }}</div>
    <div class="tender-list-cell">{{ currencySymbol }} {{ addSpaces(listSums.tools_sum) }}</div>
    <div class="tender-list-cell right-sticky-cell">
      {{ currencySymbol }} {{ addSpaces(listSums.total_sum) }}
    </div>
  </div>
</template>

<script>
  import addSpaces from '@/utils/formatting/add-spaces';
  import { mapState } from 'vuex';

  export default {
    name: 'IncomingTenderListFooter',
    props: {
      listSums: {
        type: Object,
        required: true,
      },
      currency: {
        type: String,
        required: true,
      },
    },
    computed: {
      ...mapState('global', ['currencySymbols']),
      currencySymbol() {
        return this.currencySymbols[this.currency];
      },
    },
    methods: {
      addSpaces,
    },
  };
</script>
